module.exports = __webpack_public_path__ + "assets/img/idcard_tails.103cbf9c.png";